import { render, staticRenderFns } from "./SMSApi.vue?vue&type=template&id=0b9171d8&scoped=true&"
import script from "./SMSApi.vue?vue&type=script&lang=js&"
export * from "./SMSApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9171d8",
  null
  
)

export default component.exports